<script>
import resources from './resources'

export default {
  name: 'meeting',
  mixins: [resources]
}
</script>

<template lang="pug">
.col-xl-4.col-lg-6.col-md-6.col-sm-12
  .card
    .header
      h2
        strong {{ area.name }}
      ul.header-dropdown
        li.dropdown(:class="{ show: actions }")
          a.dropdown-toggle(
            href="javascript:void(0);",
            data-toggle="dropdown",
            role="button",
            aria-haspopup="true",
            aria-expanded="false",
            @click.prevent="viewActions(actions)"
          )
            i.zmdi.zmdi-more
          ul.dropdown-menu.dropdown-menu-righ(
            x-placement="bottom-end",
            style="position: absolute; transform: translate3d(-128px, 32px, 0px); top: 0px; left: 0px; will-change: transform;",
            :class="{ show: actions }"
          )
            li
              router-link.cursor-pointer(
                :to="{ name: 'tenant.profile.schedules.me', params: { id: area.id } }"
              ) Reservas
    .body.m-b-10
      .row
        .col-sm-6(v-if="area.image")
          img.rounded(
            :src="area.image.url",
            alt="Rounded Image",
            style=" width: 100px;height: 100px;"
          )
        .col-sm-6(v-if="!area.image && area.id === 9")
          img.rounded(
            src="https://residenceohio.s3.amazonaws.com/academia.jpg",
            alt="Rounded Image",
            style=" width: 100px;height: 100px;"
          )
        .col-sm-6(v-if="!area.image && area.id ===11")
          img.rounded(
            src="https://residenceohio.s3.amazonaws.com/salao_1.jpg",
            alt="Rounded Image",
            style=" width: 100px;height: 100px;"
          )
        .col-sm-6(v-if="!area.image && area.id ===12")
          img.rounded(
            src="https://residenceohio.s3.amazonaws.com/salao_2.jpg",
            alt="Rounded Image",
            style=" width: 100px;height: 100px;"
          )
        .col-sm-6(v-if="!area.image && area.id ===15")
          img.rounded(
            src="https://residenceohio.s3.amazonaws.com/quadra_espotiva.jpg",
            alt="Rounded Image",
            style=" width: 100px;height: 100px;"
          )
        .col-6
          | {{ area.description }}
      .row
        .col-9
        .col-3
          router-link.cursor-pointer.btn.btn-raised.btn-primary.btn-icon.btn-icon-mini.btn-round(
            :to="{ name: 'tenant.profile.schedules.me', params: { id: area.id } }",
            style="background: rgb(113, 89, 193);"
          )
            i.zmdi.zmdi-calendar(style="margin-top: 9px;")
</template>
<style scoped>
.size-100 {
  width: 100%;
}
.modal-body {
  min-height: 300px;
  overflow-y: auto;
}

.cursor-pointer {
  cursor: pointer;
}
p {
  font-size: 12px;
  text-align: justify;
}
h3 {
  font-size: 12px;
  line-height: 15px;
  -webkit-transition: color 0.4s ease;
  transition: color 0.4s ease;
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/app/tenant/common-area/index/components/item.vue